import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { get } from 'lodash-es';
import CountryDropdown from './CountryDropdown';

const TaxType = ({
  taxItem,
  handleDeleteTaxType,
  indexValue,
  setTaxData,
  taxData,
  validation,
  isPayrix }) => {
  const [itemTaxType, setItemTaxType] = useState();
  const [itemFormattedTaxRate, setItemFormattedTaxRate] = useState();
  const [itemTaxHammer, setItemTaxHammer] = useState();
  const [itemTaxLiveFee, setItemTaxLiveFee] = useState();
  const [itemTaxPremium, setItemTaxPremium] = useState();
  const [errorStates, setErrorStates] = useState({
    countryError: false,
    nameError: false,
    rateError: false,
    stateError: false,
    checkBoxError: false,
  });
  const [seed, setSeed] = useState(1);

  useEffect(() => {
    setItemTaxType(taxItem.taxType);
    setItemFormattedTaxRate(taxItem.taxRate);
    setItemTaxHammer(taxItem.taxHammer);
    setItemTaxLiveFee(taxItem.taxLiveFee);
    setItemTaxPremium(taxItem.taxPremium);
    setSeed(`tax-${parseFloat(Math.random()).toFixed(2)}`);
  }, [
    taxItem,
    taxItem.taxType,
    taxItem.taxRate,
    taxItem.taxHammer,
    taxItem.taxLiveFee,
    taxItem.taxPremium
  ]);

  const inputChangeHandler = (e) => {
    e.persist();
    const { id, checked, value } = e.target;
    const newTaxDataArr = taxData;

    switch (id) {
      case 'taxType':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: value };
        setItemTaxType(value);
        break;
      case 'taxRate':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: parseFloat(value).toFixed(3) };
        setItemFormattedTaxRate(parseFloat(value).toFixed(3));
        break;
      case 'taxHammer':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: checked };
        setItemTaxHammer(checked);
        break;
      case 'taxLiveFee':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: checked };
        setItemTaxLiveFee(checked);
        break;
      case 'taxPremium':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: checked };
        setItemTaxPremium(checked);
        break;
      default:
        break;
    }
    setTaxData(newTaxDataArr);
  };

  const clearInputField = (e) => {
    if (e.currentTarget.value === '0.00') {
      e.currentTarget.value = '';
    }
  };

  const handleRateChange = (e) => {
    const { id, value } = e.target;
    const newTaxDataArr = taxData;
    newTaxDataArr[indexValue] = { ...taxData[indexValue], [id]: value ? parseFloat(value).toFixed(3) : '' };
    setItemFormattedTaxRate(value);
  };

  const dropdownOnchangeHandler = (e, type) => {
    const { value } = e;
    const newTaxDataArr = taxData;

    switch (type) {
      case 'taxCountryID':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [type]: value };
        break;
      case 'taxStateID':
        newTaxDataArr[indexValue] = { ...taxData[indexValue], [type]: value };
        break;
      default:
        break;
    }
    setTaxData(newTaxDataArr);
  };
  const handleDeleteTax = (e) => {
    e.stopPropagation();
    e.preventDefault();
    handleDeleteTaxType(indexValue);
    const elem = document.getElementById(seed);
    elem.parentElement.removeChild(elem);
  };

  useEffect(() => {
    if (validation.taxErrors) {
      validation.taxErrors.map(taxError => {
        if (taxError.errorIndex === indexValue) {
          setErrorStates({
            countryError: get(taxError, 'errorCountry', false),
            nameError: get(taxError, 'errorTaxType', false),
            rateError: get(taxError, 'errorTaxRate', false),
            stateError: get(taxError, 'errorState', false),
            checkBoxError: get(taxError, 'checkBoxError', false),
          });
        }
      });
    } else {
      setErrorStates({
        countryError: false,
        nameError: false,
        rateError: false,
        stateError: false,
        checkBoxError: false
      });
    }
  }, [validation]);

  return (

    <Container key={seed} className="mt-3">
      <div id={seed} className="mt-4">
        <Row>
          <Col xs={4}>
            <h3>Charge Type: Tax</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <FormGroup className={`${errorStates.nameError ? 'has-error' : ''}`}>
              <h3>Name</h3>
              <Input
                id="taxType"
                className=""
                maxLength={50}
                value={itemTaxType}
                onChange={inputChangeHandler}
              />
              {errorStates.nameError
                    && (
                    <div
                      className="control-label error-message mt-1"
                      htmlFor="taxTypeName"
                    >
                      Charge type is required
                    </div>
                    )}
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup className={`${errorStates.rateError ? 'has-error' : ''}`}>
              <h3>Rate %</h3>
              <Input
                id="taxRate"
                type="number"
                className=""
                maxLength="50"
                min="0"
                name="taxRate"
                value={itemFormattedTaxRate}
                onChange={handleRateChange}
                onFocus={clearInputField}
              />
              {errorStates.rateError
                    && (
                    <div
                      className="control-label error-message mt-1"
                      htmlFor="taxRate"
                    >
                      Please enter a valid tax rate %.
                    </div>
                    )}
            </FormGroup>
          </Col>

          <CountryDropdown
            currentFee={taxItem}
            type="tax"
            dropdownOnchangeHandler={dropdownOnchangeHandler}
            hasCountryError={errorStates.countryError}
            hasStateError={errorStates.stateError}
            isPayrix={isPayrix}
          />
        </Row>
        <Row>
          <Col xs={3}>
            <h3>Apply tax type to:</h3>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="taxHammer"
                name="taxHammer"
                checked={itemTaxHammer}
                onChange={inputChangeHandler}
              />
              <Label check>
                Hammer
              </Label>
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="taxLiveFee"
                name="taxLiveFee"
                checked={itemTaxLiveFee}
                onChange={inputChangeHandler}
              />
              <Label check>
                Live Fee
              </Label>
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup check>
              <Input
                type="checkbox"
                id="taxPremium"
                name="taxPremium"
                checked={itemTaxPremium}
                onChange={inputChangeHandler}
              />
              <Label check>
                BP
              </Label>
            </FormGroup>
          </Col>
          <Col xs={12} sm={3}>
            <button
              type="button"
              className="btn btn-link"
              onClick={handleDeleteTax}
            >
              Delete this tax charge
            </button>
          </Col>
        </Row>
        {errorStates.checkBoxError
          && (
          <div
            className="control-label error-message mt-1"
            htmlFor="taxTypeName"
          >
            Tax Type is Required, Please select at least one Tax Type Check Box
          </div>
          )}
      </div>
    </Container>
  );
};

export default TaxType;
